<loader *ngIf='_isLoading'></loader>

<ng-container *ngIf='!_isLoading'>
	<!-- immagine categoria -->
	<div class="master_image" id="header-image-single-tour" *ngIf='masterImage' [ngStyle]="{background: 'url(' + appService.getBaseServerAddress() + '/document_files/resize/1920x400/' + masterImage + ')'}">
		<!-- text overlay -->
		<div class="content" *ngIf='canShowSlideContent'>
			<div class="container">
				<h1 *ngIf='_tripCategoryLanguageContent.description'>{{_tripCategoryLanguageContent.description}}</h1>
				<p *ngIf='small_text'>{{small_text}}</p>
			</div>
		</div>
	</div>

	<div class="container">
		<!-- full_description -->
		<div class="row">
			<div class="col-md-12">
				<ng-container *ngIf='full_description'>
					<div class="full_description" [innerHTML]='full_description'></div>
				</ng-container>
			</div>
		</div>

		<!-- cose da fare -->
		<!--<div class="row things_to_do" *ngIf='canShowThingsToDo'>
			<div class="col-md-12">
				<h2>Cose da fare</h2>
			</div>
			<ng-container *ngIf='thingsToDoImg'>
				<div class="col-md-4 things_to_do_img">
					<img [src]="appService.getBaseServerAddress() + '/document_files/download/' + thingsToDoImg" />
				</div>
			</ng-container>

			<div [ngClass]="{'col-md-8': thingsToDoImg !== null, 'col-md-12': thingsToDoImg === null}">
				<ng-container *ngFor='let tingToDo of thingsToDo'>
					<h4>{{tingToDo[0]}}</h4>
					<p>{{tingToDo[1]}}</p>
				</ng-container>
			</div>
		</div>-->

		<list-products
			[_response]='_response'
			[_isLoading]='_isLoading'
			[_showPagination]="true"
			(changePage)='onChangePage($event)'
		></list-products>
	</div>
</ng-container>